import {
    Popup,
    NoticeBar,
    Swipe,
    SwipeItem,

    Skeleton,
    Cell,
    CellGroup,
    Field,
    Picker,
    Area,
    Empty
} from "vant";
const components = [Popup, NoticeBar, Swipe, SwipeItem, Skeleton, Cell, CellGroup, Field, Picker, Area, Empty]
export default {
    install(app) {
        components.forEach(item => {
            // item为每个组件，组件内有name、data、生命周期等等
            // app为vue实例，可以随意取名在main.js中使用use就会把vue传入进来
            // vue有component方法，第一个参数是自定义组件名字（即标签名），第二个参数就是组件
            app.component(item.name, item)
        })
    }
}